import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright 2017-2021 @polkadot/metadata authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { U32 } from '@polkadot/types/primitive';
import { assert } from '@polkadot/util';
export var MAGIC_NUMBER = 0x6174656d; // `meta`, reversed for Little Endian encoding

export var MagicNumber =
/*#__PURE__*/
function (_U) {
  _inherits(MagicNumber, _U);

  function MagicNumber(registry, value) {
    var _this;

    _classCallCheck(this, MagicNumber);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MagicNumber).call(this, registry, value));

    if (!_this.isEmpty) {
      var magic = registry.createType('u32', MAGIC_NUMBER);
      assert(_this.eq(magic), "MagicNumber mismatch: expected ".concat(magic.toHex(), ", found ").concat(_this.toHex()));
    }

    return _this;
  }

  return MagicNumber;
}(U32);